 <template>
    <b-card
        class="shippingOptionCard mb-4 box-shadow"
        :style="isAlternative && index === 0 ? 'border-width: 2px; border-color: #dc3545 !important;' : ''"
    >
        <!-- :style="isAlternative && index === 0 ? 'border-width: 5px; border-color: #dc3545 !important;' : ''" -->
        <template #header>
            <h5
                class="my-0 font-weight-normal shippingOptionCardHeader text-center"
                style="color: white"
            >{{item.quoteBooking ? $t('createShipment.quote.product' + item.transportProduct) : item.salesProductName }}</h5>
        </template>

        <b-card-body class="mt-2">
          <h5
              class="font-weight-bold text-center"
              v-if="display(fieldNames.PRICE)"
          >
            {{ item.quoteBooking ? 'N/A' : localizedNumber(getTotalPrice(item.priceLines)) }}
            <small class="text-muted">{{ getCurrency }}</small>

            <template v-if="!item.quoteBooking">

              <small class="ml-1">
                <font-awesome-icon
                    :id="'popover-target-' + index + _uid"
                    icon="question-circle"
                />

                <b-popover
                    :target="'popover-target-' + index + _uid"
                    triggers="hover"
                >
                  <template #title>Price</template>
                  <ul style="list-style-type: none; padding-left: 0px">
                    <li
                        v-for="(priceItem) in item.priceLines"
                        :key="priceItem.text"
                    >
                      {{ priceItem.text }}: {{ localizedNumber(priceItem.value) }}
                    </li>
                  </ul>

                  <p class="mb-0 mt-2 text-muted" style="font-size: 0.875rem;">
                    Price estimates are based on entered data and may not reflect final charges,
                    which depend on actual weight, dimensions, and applicable surcharges.
                  </p>
                </b-popover>
              </small>
            </template>
          </h5>
            <div class="text-center" v-if="display(fieldNames.TRANSIT_TIME)">
                <font-awesome-icon
                    icon="spinner"
                    size="lg"
                    spin
                    v-if="!item.estimatedTransitTime"
                />
                <h5 v-else class="font-weight-bold">
                    {{item.estimatedTransitTime}}
                    <small
                        v-if="!excludeDaysSuffix(item.estimatedTransitTime)"
                        class="text-muted"
                    >DAYS</small>
                </h5>
            </div>

            <b-row class="mt-3 mb-4 text-left">
                <b-col>
                    <b-row>
                        <b-col>{{item.transportProductName}}</b-col>
                    </b-row>

                    <b-row v-if="item.quoteBooking">
                        <b-col>
                            {{
                            $t('createShipment.quote.transportProduct' + item.transportProduct)
                            }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>Billable weight: {{item.billableWeight}} {{weightUnit}}.</b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            v-if="item.servicePoints && item.servicePoints.length > 0"
                        >
                            <vSelect
                                :dynamicWidth="false"
                                id="servicePoints"
                                :options="item.servicePoints"
                                :reduce="(p) => p.key"
                                label="description"
                                :placeholder="$t('createShipment.placeholder.Choose Pickup')"
                                :name="'ServicePoints_' + index"
                                v-model="item.selectedServicePoint"
                                :clearable="false"
                                class="mt-2 service-point-dropdown"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="item.priceLines">
                        <b-col>
                            <servicePrice
                                :index="index"
                                :product="item"
                                :selectedServices="selectedServices"
                                :get-shipment-price="getShipmentPrice"
                            ></servicePrice>
                        </b-col>
                    </b-row>

                    <b-row class="mt-2" v-if="item.quoteBooking">
                        <b-col>
                            <b-form-radio-group
                                id="radio-slots"
                                :name="'quoteSalesProducts_' + item.transportProductId"
                                v-model="selected"
                                stacked
                                plain
                                class="quote-radios"
                            >
                                <b-form-radio
                                    v-bind:key="selection.translationKey"
                                    v-for="selection in item.selections"
                                    :value="selection.translationKey"
                                >{{ $t('createShipment.quote.' + selection.translationKey) }}</b-form-radio>

                                <b-form-radio
                                    v-if="item.selections.length > 1"
                                    value="both"
                                    :name="'quoteSelection_' + item.transportProductId + '_0'"
                                >{{ $t('createShipment.quote.salesProductBoth', bothParams) }}</b-form-radio>
                            </b-form-radio-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-body>

        <template #footer>
            <b-input-group
                v-if="display(fieldNames.PRE_BOOKING) && !item.quoteBooking"
                size="lg"
                class="mb-2 ml-1"
            >
                <b-form-checkbox switch @input="togglePrebooking(item, $event)">
                    <h6>Prebooking</h6>
                </b-form-checkbox>
            </b-input-group>

            <p
                v-if="item.selected && anyCommodities"
                @click="$emit('show-aes', item)"
            >Edit commodities</p>

            <button
                v-if="display(fieldNames.SHOW_ALTERNATIVE_TRANSPORT_PRODUCTS) && !item.quoteBooking && item.alternativeProducts"
                type="button"
                class="btn btn-block btn-outline-dark"
                @click="$emit('show-alternatives', item)"
                :disabled="item.quoteRequested"
            >
                <span>Show alternatives ({{item.alternativeProducts.length}})</span>
            </button>

            <button
                v-if="display(fieldNames.PRE_BOOKING) && item.prebooking"
                type="button"
                class="btn btn-block btn-outline-dark"
                @click="book('create-prebooking')"
            >
                <span>Prebooking</span>
            </button>

            <button
                v-if="!item.quoteBooking && !item.prebooking"
                type="button"
                class="btn btn-block btn-outline-dark"
                @click="book('create-shipment')"
                :name="'book-' + item.salesProductName"
            >
                <span>Book</span>
            </button>

            <button
                v-if="item.quoteBooking"
                type="button"
                class="btn btn-lg btn-block btn-outline-dark"
                @click="displayRequestQuote"
                :disabled="item.quoteRequested"
            >
                <span>{{ requestQuoteButtonText }}</span>
            </button>
        </template>
    </b-card>
</template>

<script>
  import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
  import { mapState, mapGetters } from 'vuex';
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import localization from '../mixins/localizationMixin';
  import { FIELD_NAMES, EVENTS, BOOKING_TYPES } from '../store/nameConstants';
  import servicePrice from './servicePrice';
  import i18n from '../i18n';
  import viewOptions from '../mixins/viewOptionsMixin';
  import moment from 'moment';

  export default {
      props: {
          getShipmentPrice: { type: Function, required: true },
          item: { type: Object, required: true },
          index: { required: true },
          isAlternative: { type: Boolean, default: false },
      },
      mixins: [viewOptions, localization],

      components: {
          vSelect,
          servicePrice,
      },
      data() {
          return {
              selected: 'both',
              fieldNames: FIELD_NAMES,
              selectedServices: [],
          };
      },
      mounted: function () {
          if (this.item.quoteBooking) {
              const self = this;
              this.item.selections.forEach((s) => {
                  self.selected = s.translationKey; //YOYOSHIP-922: Set default to the last option which is not door to door.
              });
          }
      },

      methods: {
            book(eventName){
              let selectedServices = [];
              this.selectedServices.forEach(service => {
                selectedServices.push(service.productService)
              })
              this.item.selectedProductService = selectedServices;
              console.log('SelectedProduct',this.item)
              this.$emit(eventName, this.item);
            },
            excludeDaysSuffix(value) {
              const shippingSystem = this.getShipmentSystem;

              if (value.includes("N/A")){
                return true;
              }

              let dateFormat = 'DD-MM-YYYY';

              if (shippingSystem == 'YOYOUnitedStates') {
                  dateFormat = 'MM-DD-YYYY';
              }

              return moment(value.replace("*",""), dateFormat, true).isValid();
          },
          displayRequestQuote() {
              this.item.selections.forEach((element) => {
                  element.selected = false;
                  if (element.translationKey == this.selected || this.selected == 'both')
                      element.selected = true;
              });

              this.$emit('display-request-quote', {
                  quoteProduct: this.item,
                  selected: this.selected,
              });
          },

          togglePrebooking(item, event) {
              item.prebooking = event;
          },

          getTotalPrice(priceLines) {
              let totalPrice = 0;

              priceLines.forEach((element) => (totalPrice += element.value));

              return totalPrice;
          },
      },
      computed: {
          ...mapGetters('core', ['getShipmentSystem']),
          ...mapGetters('createShipment', ['getShipment']),
          weightUnit(){
            const shippingSystem = this.getShipmentSystem;
            if (shippingSystem === 'YOYOUnitedStates') {
              return 'lb';
            }
            return "kg"
          },
          bothParams() {
              if (this.item.selections.length > 1) {
                  return {
                      first: i18n.t('createShipment.quote.' + this.item.selections[0].translationKey),
                      second: i18n.t(
                          'createShipment.quote.' + this.item.selections[1].translationKey
                      ),
                  };
              }
              return {
                  first: i18n.t('createShipment.quote.' + this.item.selections[0].translationKey),
                  second: i18n.t('createShipment.quote.' + this.item.selections[0].translationKey),
              };
          },

          anyCommodities() {
              return this.getShipment.customsAmount.commodities != null && this.getShipment.customsAmount.commodities.length > 0;
          },

          getCurrency() {
              const shippingSystem = this.getShipmentSystem;

              if (shippingSystem === 'YOYODenmark') {
                  return 'DKK';
              }

              if (shippingSystem === 'YOYONorway') {
                  return 'NOK';
              }

              if (shippingSystem === 'YOYOUnitedStates') {
                  return 'USD';
              }

              if (shippingSystem === 'YOYOSweden') {
                  return 'SEK';
              }

              return '';
          },

          requestQuoteButtonText() {
              if (!this.item.quoteRequested) {
                  return i18n.t('createShipment.button.requestQuote');
              }

              return i18n.t('createShipment.button.quoteRequested');
          },
      },
  };
</script>


<style>
  .shippingOptionCard {
      min-width: 18%;
      max-width: 18%;
  }

  .shippingOptionCardHeader {
      display: table-cell;
      vertical-align: middle;
  }

  .card-deck .card {
      margin: 1%;
  }

  .card-footer {
      background-color: white;
      border-top: 0;
  }

  .card-header {
      min-height: 19%;
      display: flex;
      justify-content: center;
      align-items: center;
  }
</style>